// extracted by mini-css-extract-plugin
module.exports = {"container":"tabsPagination_container__6N0Zz","iconContainer":"tabsPagination_iconContainer__PdKXi","iconButton":"tabsPagination_iconButton__uj1ZM"};